class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/punctuate`;
    }
    /**
     * Returns Smart Punctuation to the provided webhook URI.
     * HTTP Method: post
     * Endpoint: /ai/text/v1/async/punctuate
     * Rate Limit Group: Heavy
     * App Permission: AI
     */
    async post(punctuateInput, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), punctuateInput, queryParams, restRequestConfig);
        return r.data;
    }
}
export default Index;
